export default "__VITE_ASSET__1ZqB_GXU__"